/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { noop } from 'lodash';

import useVehicleFilterStore from 'Stores/FilterStore/VehicleListFilter/VehicleListFilterStore';
import { isUndefined } from 'Utilities/helpers';
import usePrevious from 'Utilities/hooks/usePrevious';
import proPropTypes from 'Utilities/proPropTypes';

import ExpandableListItem from '../ExpandableListItem/ExpandableListItem';

import styles from './ExpandableFilter.module.scss';

const ExpandableFilter = ({ badge, children, classNames, defaultExpanded, id, isDirty, onClick, title }) => {
	const isCollapsed = useVehicleFilterStore(useCallback((store) => store.collapsedFilters[id], [id]));
	const setIsFilterCollapsed = useVehicleFilterStore((store) => store.setIsFilterCollapsed);
	const isExpanded = isUndefined(isCollapsed) ? isDirty || defaultExpanded : !isCollapsed;
	const noTransition = isUndefined(isCollapsed) && (isDirty || defaultExpanded);
	const isExpandedPrevious = usePrevious(isExpanded);
	const isAnimated = !isExpanded && isExpandedPrevious;
	const childClassNames = {
		animateContent: styles.animateContent,
		animateHeader: styles.animateHeader,
		container: cx(classNames.container, styles.container),
		content: cx(classNames.content, styles.content),
		contentWrapper: cx(classNames.contentWrapper, styles.contentWrapper),
		expanded: cx(classNames.expanded, styles.expanded),
		header: cx(classNames.header, styles.header),
	};

	const onListItemClick = (expanded) => {
		setIsFilterCollapsed({ expanded, id });
		onClick(expanded);
	};

	return (
		<ExpandableListItem
			{...{
				badge,
				children,
				classNames: childClassNames,
				id,
				isAnimated,
				isDirty,
				isExpanded,
				isSmall: true,
				noTransition,
				onClick: (expanded) => onListItemClick(expanded),
				shouldShowBadge: Boolean(badge),
				title,
			}}
		/>
	);
};

ExpandableFilter.defaultProps = {
	classNames: {},
	defaultExpanded: false,
	isDirty: false,
	onClick: noop,
};

ExpandableFilter.propTypes = {
	badge: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	children: PropTypes.node.isRequired,
	classNames: PropTypes.shape({
		container: proPropTypes.className,
		content: proPropTypes.className,
		contentWrapper: proPropTypes.className,
		expanded: proPropTypes.className,
		header: proPropTypes.className,
	}),
	defaultExpanded: PropTypes.bool,
	id: PropTypes.string.isRequired,
	isDirty: PropTypes.bool,
	onClick: PropTypes.func,
	title: PropTypes.node.isRequired,
};

export default ExpandableFilter;
